export type MediaCategory = 
  | "Campaign Announcements"
  | "Education Reform"
  | "Election Integrity"
  | "Second Amendment"
  | "Curriculum Policy"
  | "Student Discipline";

export interface MediaArticle {
  id: string;
  title: string;
  source: string;
  url: string;
  date?: string;
  category: MediaCategory;
  featured?: boolean;
  imageUrl?: string;
}

export const mediaCategories: MediaCategory[] = [
  "Campaign Announcements",
  "Education Reform",
  "Election Integrity",
  "Second Amendment",
  "Curriculum Policy",
  "Student Discipline",
];

export const mediaArticles: MediaArticle[] = [
  // Campaign Announcements
  {
    id: "campaign-1",
    title: "Milford Board of Education's Bucher to Seek House Seat in General Assembly",
    source: "Bay to Bay News",
    url: "https://baytobaynews.com/stories/milford-board-of-educations-bucher-to-seek-house-seat-in-general-assembly,273187",
    category: "Campaign Announcements",
    featured: true,
  },
  {
    id: "campaign-2",
    title: "Bucher Files for 33rd District House Seat",
    source: "Milford Live",
    url: "https://milfordlive.com/bucher-files-for-33rd-district-house-seat/",
    category: "Campaign Announcements",
  },
  {
    id: "campaign-3",
    title: "Matt Bucher Files to Run for Delaware House District 33 in 2026",
    source: "Coast TV",
    url: "https://www.coasttv.com/news/matt-bucher-files-to-run-for-delaware-house-district-33-in-2026/article_5b9d94be-96e9-44c3-8c73-e40d8378b00c.html",
    category: "Campaign Announcements",
  },
  {
    id: "campaign-4",
    title: "Bucher Announces Candidacy for Representative Seat",
    source: "Milford Times",
    url: "https://milford-times.com/bucher-announces-candidacy-for-representative-seat/",
    category: "Campaign Announcements",
  },
  {
    id: "campaign-5",
    title: "Matt Bucher Files to Run for 33rd District DE House Seat",
    source: "WGMD",
    url: "https://www.wgmd.com/matt-bucher-files-to-run-for-33rd-district-de-house-seat/",
    category: "Campaign Announcements",
  },
  
  // Education Reform
  {
    id: "education-1",
    title: "How Lawmakers Can Improve Schools Now",
    source: "Bay to Bay News",
    url: "https://baytobaynews.com/stories/bucher-how-lawmakers-can-improve-schools-now,259997",
    category: "Education Reform",
  },
  {
    id: "education-2",
    title: "Free Our Schools: Six Ways the Delaware General Assembly Can Cut Costs and Improve Outcomes Right Now",
    source: "A Better Delaware",
    url: "https://www.abetterdelaware.org/2025/09/22/free-our-schools-six-ways-the-delaware-general-assembly-can-cut-costs-and-improve-outcomes-right-now/",
    category: "Education Reform",
  },
  
  // Election Integrity
  {
    id: "election-1",
    title: "What's Not Being Said About the Voting Rights Bills",
    source: "Bay to Bay News",
    url: "https://baytobaynews.com/stories/commentary-whats-not-being-said-about-the-voting-rights-bills,70841",
    category: "Election Integrity",
  },
  
  // Second Amendment
  {
    id: "2a-1",
    title: "There Will Never Be Enough Gun Control for the Left",
    source: "Bay to Bay News",
    url: "https://baytobaynews.com/daily-state-news/stories/commentary-there-will-never-be-enough-gun-control-for-left,19749",
    category: "Second Amendment",
  },
  
  // Curriculum Policy
  {
    id: "curriculum-1",
    title: "MSD Board Approves Curriculum Development Changes",
    source: "Milford Times",
    url: "https://milford-times.com/msd-board-approves-curriculum-development-changes/",
    category: "Curriculum Policy",
  },
  {
    id: "curriculum-2",
    title: "New Milford Curriculum Policy May Drive Away Educators, Critics Say",
    source: "Bay to Bay News",
    url: "https://baytobaynews.com/milford-harrington/stories/new-milford-curriculum-policy-may-drive-away-educators-critics-say,248945",
    category: "Curriculum Policy",
  },
  {
    id: "curriculum-3",
    title: "Milford School Board Passes Controversial Curriculum Policy",
    source: "Delaware Public Media",
    url: "https://www.delawarepublic.org/delaware-headlines/2025-09-03/milford-school-board-passes-controversial-curriculum-policy",
    category: "Curriculum Policy",
  },
  {
    id: "curriculum-4",
    title: "Few Details Available About Milford's New Politics in Classrooms Policy",
    source: "Spotlight Delaware",
    url: "https://spotlightdelaware.org/2025/09/22/few-details-available-about-milfords-new-politics-in-classrooms-policy/",
    category: "Curriculum Policy",
    featured: true,
    imageUrl: "/src/assets/spotlight-article.png",
  },
  
  // Student Discipline
  {
    id: "discipline-1",
    title: "Milford Scraps Restorative Practices from Code",
    source: "Delaware Live",
    url: "https://delawarelive.com/milford-scraps-restorative-practices-from-code/",
    category: "Student Discipline",
  },
  {
    id: "discipline-2",
    title: "Milford School Board Changes Code of Conduct, Striking Restorative Practices Endorsement",
    source: "Bay to Bay News",
    url: "https://baytobaynews.com/stories/milford-school-board-changes-code-of-conduct-striking-restorative-practices-endorsement,113752",
    category: "Student Discipline",
  },
  {
    id: "discipline-3",
    title: "Student Code of Conduct Discussed at School Board",
    source: "Milford Live",
    url: "https://milfordlive.com/student-code-of-conduct-discussed-at-school-board/",
    category: "Student Discipline",
  },
];
